import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqItems = [
  { q: 'faq.q1', a: 'faq.a1' },
  { q: 'faq.q2', a: 'faq.a2' },
  { q: 'faq.q3', a: 'faq.a3' },
  { q: 'faq.q4', a: 'faq.a4' },
];

export default function Faq() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20 scroll-mt-20 md:scroll-mt-24">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-center font-heading text-2xl md:text-3xl font-bold tracking-tight text-foreground-950">
          {t('faq.title')}
        </h2>

        <div className="mt-8 space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-900">
                    {t(item.q)}
                  </span>
                  <span className={`w-5 h-5 flex items-center justify-center text-foreground-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-lg" aria-hidden="true"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{t(item.a)}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}